<script>


	export let bot;
    
	const changeChatUrl = (e) => {
        let chatUrl = e.target.value;
        bot.changeChatUrl(chatUrl);
    }
</script>
<div class="moving-button">
	<div class="text-block-103">AI챗 연결하기</div>
</div>
<div class="link-block-wrap">
	<div class="link-block-form">
		<div class="div-block-76">
			<div class="link-input-form w-form" on:click|stopPropagation>
				<div id="email-form" name="email-form" class="link-form">
					<input type="text" class="name-text-form w-input" autofocus="true" maxlength="256" name="field" placeholder="AI챗 링크를 입력해주세요!" id="field-3" value={bot.chatUrl} on:blur={(e)=>changeChatUrl(e)} on:change={(e)=>changeChatUrl(e)}>
				</div>
			</div>
		</div>
	</div>
</div>
<style>
	.text-block-103 {
    	width: 160px;
	}
	.link-block-wrap {
		width: 420px;
		margin-top: 0px;
	}

	.link-block-form {
		margin-top: 0px;
		width: 100%;
	}

	.moving-button {
		margin-top: 10px;
		margin-bottom: 14px;
	}
	.link-input-form {
		width: -webkit-fill-available;
	}
	.name-text-form {
		width: 100%;
	}
	.link-form {
		border-radius: 3px;
    	padding: 5px 14px;
		height: 37px;
	}
</style>